import { render, staticRenderFns } from "./BatchUpdateDistrictUnits.vue?vue&type=template&id=57d82447&scoped=true&"
import script from "./BatchUpdateDistrictUnits.vue?vue&type=script&lang=js&"
export * from "./BatchUpdateDistrictUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d82447",
  null
  
)

export default component.exports